<template>
  <card shadow class="flex items-center">
    <img :src="img" class="mb-2 mr-4 h-10 md:h-14" />
    <h6 class="font-bold text-sm md:text-2xl flex-1 ">Kunjungi laman website kami</h6>
    <x-link :to="url"><b-button type="is-warning-gradient">WEBSITE</b-button></x-link>
  </card>
</template>

<script>
import img from '@/assets/ipost/web.png'
import XLink from '@/components/link/Link'
import Card from './Card'
export default {
  components: {
    Card,
    XLink
  },
  props: {
    url: String
  },
  data () {
    return {
      img
    }
  }
}
</script>

<style>

</style>
